import { actions } from './ReceiptReducer';

export function attemptResetReceiptNotificationState(data) {
  return { type: actions.ATTEMPT_RESET_NOTIFICATION_STATE, payload: { data } };
}

export function attemptGetReceipt(data) {
  return { type: actions.ATTEMPT_GET_RECEIPT, payload: { data } };
}

export function attemptGetReceiptSucceed(data) {
  return { type: actions.ATTEMPT_GET_RECEIPT_SUCCEED, payload: { data } };
}

export function attemptGetReceiptFailed(data) {
  return { type: actions.ATTEMPT_GET_RECEIPT_FAILED, payload: { data } };
}

export function attemptUpdateReceipt(data) {
  return { type: actions.ATTEMPT_UPDATE_RECEIPT, payload: { data } };
}

export function attemptUpdateReceiptSucceed() {
  return { type: actions.ATTEMPT_UPDATE_RECEIPT_SUCCEED };
}

export function attemptUpdateReceiptFailed(data) {
  return { type: actions.ATTEMPT_UPDATE_RECEIPT_FAILED, payload: { data } };
}

export function attemptSearchReceipt(data) {
  return { type: actions.ATTEMPT_SEARCH_RECEIPT, payload: { data } };
}

export function attemptSearchReceiptSucceed(data) {
  return { type: actions.ATTEMPT_SEARCH_RECEIPT_SUCCEED, payload: { data } };
}

export function attemptSearchReceiptFailed(data) {
  return { type: actions.ATTEMPT_SEARCH_RECEIPT_FAILED, payload: { data } };
}
